/**
 * Map Component Constants
 *
 * Centralized constants to prevent magic strings and typos.
 * These constants provide type safety and a single source of truth
 * for state values used across map components.
 */

/**
 * Mobile view states for map interface
 */
export const MobileView = {
  MAP: 'map',
  LIST: 'list',
  FILTERS: 'filters',
} as const;

export type MobileViewType = (typeof MobileView)[keyof typeof MobileView];

/**
 * Location types for pickup locations
 */
export const LocationType = {
  TOUR: 'Tour',
  MARKET: 'Market',
  NASHVILLE: 'Nashville',
} as const;

export type LocationTypeValue = (typeof LocationType)[keyof typeof LocationType];

/**
 * Inventory status types
 */
export const InventoryStatus = {
  SOLD_OUT: 'sold_out',
  HURRY_UP: 'hurry_up',
  AVAILABLE: 'available',
} as const;

export type InventoryStatusType = (typeof InventoryStatus)[keyof typeof InventoryStatus];

/**
 * Badge styles for location types
 * Maps location type to Tailwind CSS classes
 */
export const LOCATION_TYPE_BADGE_STYLES: Record<LocationTypeValue, string> = {
  [LocationType.TOUR]: 'bg-blue-100 text-blue-800',
  [LocationType.MARKET]: 'bg-purple-100 text-purple-800',
  [LocationType.NASHVILLE]: 'bg-brand-soft text-brand',
};
